import styled from "styled-components";
import { Card, Image, Space, Table, Typography, Dropdown } from "antd";
import NoImageSmall from "../../../assets/images/NoImageSmall.svg";
import { ReactComponent as ThreeDotsVertical } from "../../../assets/icons/ThreeDotsVertical.svg";
import CardImageFallback from "../../../assets/images/CardImageFallback.svg";

const { Meta } = Card;
const { Text } = Typography;

export const TableRowActionsButton = styled(Dropdown)`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const StyledCardTableLayout = styled(Space).attrs({
  size: [55, 25],
  direction: "horizontal",
})`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 40px;
  max-height: 80vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5f5df0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const StyledTable = styled(Table).attrs({
  tableLayout: "auto",
})`
  border-radius: 0.5rem;
  margin-top: 1.5rem;
  box-shadow: 0px 0.5px 1px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1);

  .ant-table-thead > tr > th {
    border-bottom: none;
    font-size: 12px;
    font-weight: 400;
    font-color: #808080;
    line-height: 24px;
    color: #808080;
    height: 2.75rem;
  }
  .ant-table-column-sorter-up.active,
  .ant-table-column-sorter-down.active {
    color: inherit;
  }

  .ant-table-content::-webkit-scrollbar {
    width: 1px;
  }

  .ant-table-content::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .ant-table-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .ant-table-tbody > tr > td:last-child,
  .ant-table-thead > tr > th:last-child {
    width: 3rem;
  }
`;

export const StyledExtendedTableCell = styled(Space).attrs({
  direction: "horizontal",
  size: "middle",
})`
  display: flex;
  flex-direction: row;
  align-items: center;

  .ant-space-item {
    font-size: 14px;
    font-weight: 400;
    color: #313131;
  }
`;

export const StyledTableActionsButton = styled(Dropdown).attrs({
  overlayStyle: { direction: "rtl" },
})`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const StyledExtendedCellTitle = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const StyledExtendedCellImage = styled(Image).attrs({
  height: "2.75rem",
  width: "7.25rem",
  fallback: NoImageSmall,
  preview: false,
})`
  padding: 0;
  margin: 0;
  border: none !important;
  outline: none;
  background: #f1f1f1;
  border-radius: 4px 4px 4px 4px;
  object-fit: cover;

  .ant-image-img {
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none;
  }

  .ant-image-mask,
  .ant-image-preview {
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
`;

export const StyledExtendedCellContent = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})`
  display: flex;
  align-items: center;
`;

export const StyledThreeDotsVertical = styled(ThreeDotsVertical)`
  width: 20px;
  height: 20px;
`;

export const StyledCard = styled(Card)`
  width: 16.688rem;
  border-radius: 1rem;
  box-shadow: 0px 0px 4px 0px #0000001a;
  padding: 0;
  position: relative;

  .ant-card-body {
    padding: 0;
  }

  .ant-image-mask {
    border-radius: 0.5rem;
  }
`;

export const StyledCardImage = styled(Image).attrs({
  preview: false,
  fallback: CardImageFallback,
})`
  min-height: 8.563rem;
  height: 8.563rem;
  max-height: 8.563rem;
  width: 100%;
  border-radius: inherit;
  object-fit: cover;
  object-position: top;

  .ant-image-error img {
    border: 2px dashed red;
    height: 6rem !important;
    width: 6rem !important;
    opacity: 0.8;
  }
`;

export const StyledCardMeta = styled(Meta)`
  padding: 0.5rem 1rem;
  cursor: pointer;

  .ant-card-meta-title {
    margin-bottom: 0 !important;
    font-size: 14px;
    font-weight: 400;
    color: #313131;
  }

  .ant-card-meta-description {
    font-size: 14px;
    font-weight: 400;
    color: #808080;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledCardMetaTitle = styled.div`
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledCardMetaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  cursor: pointer;
  height: 70px;
`;

export const CardActionsButton = styled(Dropdown).attrs({
  overlayStyle: { direction: "rtl" },
})`
  position: absolute;
  width: 20px;
  height: 20px;
  cursor: pointer;
  top: 0.5rem;
  left: 0.5rem;
  color: red;
`;
